export default __webpack_public_path__ + "static/media/menu.9127a27f.svg";